<template>
  <div>
    <v-app-bar app elevation="2" class="app-bar-color">
      <v-row align="start" no-gutters>
        <v-col cols="1">
          <v-img :src="NavBarLogo" height="45" />
        </v-col>
        <v-col cols="6">
          <v-app-bar-title class="font-weight-bold text-white mt-2 ml-1">
            Partner Management System
          </v-app-bar-title>
        </v-col>
      </v-row>

      <v-spacer></v-spacer>

      <v-btn to="/teams" variant="text" class="text-white mr-2" align
        ><v-icon color="white" class="mr-2">mdi-account-group</v-icon> Teams
      </v-btn>

      <v-btn @click="openOnboardDialog" variant="text" class="text-white">
        <v-icon color="white" class="mr-2">mdi-plus-circle</v-icon>
        Onboard
      </v-btn>

      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" icon elevation="0">
            <v-avatar size="35" color="transparent"
              ><v-icon color="white">mdi-account</v-icon></v-avatar
            >
          </v-btn>
        </template>

        <v-card width="240" class="avatar-card-color" rounded="lg">
          <div class="d-flex align-center">
            <v-icon color="white" class="ml-2 mt-4">mdi-email-outline</v-icon>
            <div class="ml-3 mt-4 text-white">
              <i>{{ user.email }}</i>
            </div>
          </div>

          <v-card-actions class="d-flex justify-center">
            <v-btn @click="handleLogout" icon elevation="0" size="35">
              <v-icon color="white">mdi-logout</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>

    <OnboardDialog v-model="onboardDialog" @team-created="onTeamCreated" />
  </div>
</template>

<script>
import NavBarLogo from "@/assets/NavBarLogo.png";
import { mapGetters, mapActions } from "vuex";
import OnboardDialog from "@/components/Dialogs/OnboardDialog.vue";
import { signOut } from "aws-amplify/auth";
import { generateClient } from "aws-amplify/api";
import { get_current_partner_details } from "@/graphql/queries.js";

const client = generateClient();

export default {
  name: "NavbarComponent",
  components: {
    OnboardDialog,
  },
  data() {
    return {
      NavBarLogo,
      onboardDialog: false,
      loading: false,
    };
  },
  mounted() {
    this.fetchPartnerDetails();
  },
  computed: {
    ...mapGetters(["getUser"]),
    user() {
      return this.getUser || {};
    },
  },
  methods: {
    ...mapActions(["logout"]),

    async fetchPartnerDetails() {
      this.loading = true;
      try {
        const result = await client.graphql({
          query: get_current_partner_details,
        });

        if (result.data.get_current_partner_details) {
          const response = JSON.parse(result.data.get_current_partner_details);

          if (response.Status === "SUCCESS") {
            this.$store.dispatch("setPartnerDetails", response.data[0]);
          } else {
            console.error("Failed to fetch partner details:", response.Message);
            this.$store.dispatch("setNotification", {
              type: "error",
              message: response.Message || "Failed to fetch partner details",
            });
          }
        }
      } catch (error) {
        console.error("Error fetching partner details:", error);
        this.$store.dispatch("setNotification", {
          type: "error",
          message: "Failed to fetch partner details. Please try again.",
        });
      } finally {
        this.loading = false;
      }
    },

    async handleLogout() {
      await signOut({ global: true });
      this.$router.push("/login");
      await this.logout();
    },

    openOnboardDialog() {
      this.onboardDialog = true;
    },

    onTeamCreated(newTeam) {
      this.$store.dispatch("addTeam", newTeam);

      this.$store.dispatch("setNotification", {
        type: "success",
        message: "Team onboarded successfully!",
      });
    },
  },
};
</script>

<style scoped>
.v-app-bar {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  backdrop-filter: blur(10px) !important;
}

.app-bar-color {
  background: linear-gradient(
    90deg,
    #3f78e0 0%,
    #da4c77 50%,
    #3f78e0 100%
  ) !important;
  background-size: 200% 100% !important;
  animation: colorFlow 4s linear infinite !important;
}

@keyframes colorFlow {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
}

.v-chip {
  border-width: 1px;
  font-weight: 500;
}

.v-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.v-btn:hover {
  transform: translateY(-1px);
  transition: transform 0.2s ease;
}

.v-divider {
  opacity: 0.3;
}

.avatar-card-color {
  background: linear-gradient(135deg, #3f78e0 0%, #da4c77 100%) !important;
}
</style>
